import script from "./marketing-consent.vue?vue&type=script&setup=true&lang=ts"
export * from "./marketing-consent.vue?vue&type=script&setup=true&lang=ts"

import "./marketing-consent.vue?vue&type=style&index=0&id=50f9587a&lang=scss&scoped=true"

import exportComponent from "/Users/macmini/builds/VJ28wZh6J/1/terracycle/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f9587a"]])

export default __exports__